import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import { Tooltip } from '@mui/material';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import ConditionalWrapper from '~/modules/common/components/ConditionalWrapper';

const useTooltipContentStyles = makeStyles(theme => ({
  noRoleLabel: {
    fontStyle: 'italic'
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5)
  },
  divider: {
    borderTop: `1px solid ${theme.palette.common.white}`,
    marginBottom: theme.spacing(0.5)
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    columnGap: theme.spacing(0.5),
    rowGap: theme.spacing(1)
  },
  roleLabel: {
    ...theme.typography.caption,
    color: theme.palette.text.secondary
  }
}));

export const TaskAssignmentRole = ({
  projectRole,
  isRmp2025Q4Enhancements
}) => {
  const tooltipClasses = useTooltipContentStyles();

  const tooltipContent = useMemo(
    () => (
      <>
        <div className={tooltipClasses.title}>
          <FormattedMessage id="taskAssignments.tooltipTitle" />
        </div>
        <div className={tooltipClasses.divider} />
        <div className={tooltipClasses.container}>
          <FormattedMessage id="taskAssignments.taskAssignedRole" />
          {projectRole ? (
            projectRole.displayText
          ) : (
            <div className={tooltipClasses.noRoleLabel}>
              <FormattedMessage id="taskAssignments.noRole" />
            </div>
          )}
        </div>
      </>
    ),
    [projectRole, tooltipClasses]
  );

  return (
    <ConditionalWrapper
      condition={isRmp2025Q4Enhancements}
      WrapperComponent={Tooltip}
      title={tooltipContent}
      placement="top"
    >
      <Typography
        className={classNames(tooltipClasses.roleLabel, {
          [tooltipClasses.noRoleLabel]: !projectRole
        })}
      >
        {projectRole ? (
          projectRole.displayText
        ) : (
          <FormattedMessage id="taskAssignments.noRole" />
        )}
      </Typography>
    </ConditionalWrapper>
  );
};

TaskAssignmentRole.propTypes = {
  projectRole: PropTypes.object,
  isRmp2025Q4Enhancements: PropTypes.bool
};

export default TaskAssignmentRole;
